import axios from 'axios'
import CONFIG from '@/config/config'
const PRE_FIX = CONFIG.API_URL // + (CONFIG.PROFILE === 'production' ? '/api':'')
import Vue from 'vue'

let checkParams = function(params) {
    let checkObj = $.extend(true,{},params)
    let checkedKeys = Object.keys(checkObj).filter(key => key !== 'page' && !checkObj[key])
    checkedKeys.forEach(function(key) {
        delete checkObj[key]
    })
    return  checkObj
}

export default {
    async getLogs(params) {
        return await axios.get(PRE_FIX + '/v1/ums/logs',{params: checkParams(params)}).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        })
    },
    async getLogDetail(seq) {
        return await axios.get(PRE_FIX + '/v1/ums/log/' + seq).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        })
    },
}
